import React from "react";

const DonistaLogo: React.FC<React.SVGProps<SVGSVGElement>> = (props) => (
    <svg
        role="img"
        viewBox="0 0 382 382"
        xmlns="http://www.w3.org/2000/svg"
        width="382px"
        height="382px"
        style={{
            shapeRendering: "geometricPrecision",
            textRendering: "geometricPrecision",
            fillRule: "evenodd",
            clipRule: "evenodd",
        }}
        {...props}
    >
        <g>
            <path
                style={{ opacity: 1 }}
                fill="#b2585f"
                d="M 319.5,13.5 C 287.167,13.5 254.833,13.5 222.5,13.5C 222.833,86.0019 222.499,158.335 221.5,230.5C 221.5,157.833 221.5,85.1667 221.5,12.5C 254.338,12.1684 287.004,12.5017 319.5,13.5 Z"
            />
        </g>
        <g>
            <path
                style={{ opacity: 1 }}
                fill="#8d0a14"
                d="M 319.5,13.5 C 319.98,93.5271 319.48,173.527 318,253.5C 307.732,324.102 267.232,364.268 196.5,374C 128.574,377.132 81.0743,347.632 54,285.5C 34.1169,211.788 56.9502,155.622 122.5,117C 148.91,104.358 176.577,100.524 205.5,105.5C 206.16,140.849 205.493,175.849 203.5,210.5C 179.331,197.502 160.831,203.169 148,227.5C 141.891,251.114 150.057,267.614 172.5,277C 194.157,282.032 209.324,274.532 218,254.5C 220.148,246.648 221.315,238.648 221.5,230.5C 222.499,158.335 222.833,86.0019 222.5,13.5C 254.833,13.5 287.167,13.5 319.5,13.5 Z"
            />
        </g>
        <g>
            <path
                style={{ opacity: 1 }}
                fill="#9c242e"
                d="M 205.5,105.5 C 206.664,140.998 206.831,176.664 206,212.5C 205.005,211.934 204.172,211.267 203.5,210.5C 205.493,175.849 206.16,140.849 205.5,105.5 Z"
            />
        </g>
    </svg>
);

export default DonistaLogo;
